var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "printMe" },
    [
      _c("cusHeader"),
      _vm._v(" "),
      _vm.step === 0
        ? _c(
            "b-container",
            [
              _c("h3", { staticClass: "mt-3 mb-4" }, [
                _vm._v("Informe de la consulta")
              ]),
              _vm._v(" "),
              _c("Report", { ref: "customReport" }),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { "align-h": "end" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-info" },
                      on: { click: _vm.cancelAndReturn }
                    },
                    [_vm._v("Cancelar y volver")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { variant: "outline-danger" },
                      on: { click: _vm.skipReport }
                    },
                    [_vm._v("Omitir informe y continuar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { variant: "primary" },
                      on: { click: _vm.gotoTreatment }
                    },
                    [_vm._v("Continuar")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.step === 1
        ? _c(
            "b-container",
            [
              _c("h3", { staticClass: "mt-3 mb-4" }, [_vm._v("Tratamiento")]),
              _vm._v(" "),
              _c("Treatment", { ref: "customTreatment" }),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { "align-h": "end" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-info" },
                      on: { click: _vm.returnReport }
                    },
                    [_vm._v("atrás")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { variant: "primary" },
                      on: { click: _vm.show_dialogCommitTreatment }
                    },
                    [_vm._v("Finalizar")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          okFn: _vm.dialogCommitTreatment_okFn,
          cancelFn: _vm.dialogCommitTreatment_cancelFn,
          okBtnText: "Aceptar",
          cancelBtnText: "Cancelar",
          content: "¿Desea finalizar y enviar el tratamiento?"
        },
        model: {
          value: _vm.dialogCommitTreatment,
          callback: function($$v) {
            _vm.dialogCommitTreatment = $$v
          },
          expression: "dialogCommitTreatment"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d53796b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d53796b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/professional/EsNodofarma.vue
// module id = 3904
// module chunks = 28